import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ListAssociacaoAuditoriaComponent } from './../list-associacao-auditoria/list-associacao-auditoria.component';

@Component({
  selector: 'app-list-nova-associacao-auditora',
  templateUrl: './list-nova-associacao-auditora.component.html',
  styleUrls: ['./list-nova-associacao-auditora.component.scss']
})
export class ListNovaAssociacaoAuditoraComponent implements OnInit {

  @Input() formulario;
  @ViewChild(ListAssociacaoAuditoriaComponent, { static: false }) listaAssociacao: ListAssociacaoAuditoriaComponent;

  constructor() { }

  ngOnInit() {
  }

  updateListAssociacao(r) {
    this.listaAssociacao.updateResult();
  }

}
